'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasUnansweredQuickReplyMessage = undefined;

var _reselect = require('reselect');

var _getCurrentConversation = require('./conversationSelectors/getCurrentConversation');

var _pubnubMessageGetters = require('conversations-schema/pubnub-message/operators/pubnubMessageGetters');

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _hasMessages = require('conversations-schema/thread-history/operators/hasMessages');

var _getMessages = require('conversations-schema/thread-history/operators/getMessages');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _historyDataForThread = require('../thread-histories/selectors/historyDataForThread');

var hasUnansweredQuickReplyMessage = exports.hasUnansweredQuickReplyMessage = (0, _reselect.createSelector)([_getCurrentConversation.getCurrentConversation, _historyDataForThread.historyDataForThread], function (currentConversation, history) {
  if (!history || !(0, _hasMessages.hasMessages)(history)) {
    return false;
  }

  var presentationalMessages = (0, _getMessages.getMessages)(history).filter(_messageTypeComparators.isPresentationalMessage);

  var mostRecentMessage = presentationalMessages.last();
  var hasQuickReplyOptions = (0, _pubnubMessageGetters.getQuickReply)(mostRecentMessage);
  var senderType = (0, _commonMessageFormatGetters.getSenderType)(mostRecentMessage);
  var allowUserInput = (0, _pubnubMessageGetters.getAllowUserInput)(mostRecentMessage);

  return Boolean(hasQuickReplyOptions && senderType === _senderTypes.BOT && allowUserInput === false);
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/chatSelectors.js
// module id = 632
// module chunks = 2 3